const WinlosesTypes = {
    FETCH_START:    '[HOSTESS][WINLOSES] FETCH START',
    FETCH_SUCCESS:  '[HOSTESS][WINLOSES] FETCH SUCCESS',
    FETCH_FAILURE:  '[HOSTESS][WINLOSES] FETCH FAILURE'
};

export default WinlosesTypes;